exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[kv]{height:26.66666667rem;background-repeat:no-repeat}[kv].join{background-image:url(\"/static/img/common/kv-join.png\")}[kv].complaint,[kv].join{background-size:cover;background-position:50%}[kv].complaint{background-image:url(\"/static/img/common/kv-complaint.png\")}[kv].my{background-image:url(\"/static/img/common/kv-my.png\")}[kv].cs,[kv].my{background-size:cover;background-position:50%}[kv].cs{background-image:url(\"/static/img/common/kv-cs.png\")}[kv].cert{background-image:url(\"/static/img/common/kv-cert.png\")}[kv].anew,[kv].cert{background-size:cover;background-position:50%}[kv].anew{background-image:url(\"/static/img/common/kv-anew.png\")}[kv] h2{padding-top:14.16666667rem;font-size:4.66666667rem;line-height:1;text-align:center;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-518ab39e","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/front/component/KeyVisual.vue
// module id = f4bb
// module chunks = 241